import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {PartnerModel} from '../../../api/model/partner.model';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';

@Injectable({
    providedIn: 'root'
})
export class PartnerRepository extends AbstractRepositoryV2<PartnerModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Partner', serviceElementsFactory, injector);
    }
}
